import { render } from "./Insights.vue?vue&type=template&id=d94abb40"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__